
  var path = 'blocks/modals/modal-report-address/typeahead-item.tpl.jade';
  var html = "<!-- preventDefault нужен, чтобы не вызывать blur на инпуте--><a ng-mousedown=\"$event.preventDefault()\" class=\"typeahead-item\"><span ng-bind-html=\"match.model.value | uibTypeaheadHighlight:query\" ng-attr-title=\"{{match.model.value}}\"></span></a>";
  window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
  module.exports = path;
  